export class MarkerType {
  constructor(newMarkerType) {
    this.id = newMarkerType.id;
    this.name = newMarkerType.name;
    this.markerUrl = newMarkerType.marker_url;
  }
}